import { CustomQueryOptions } from '@/common/types_and_interfaces'
import { MarketplaceStore } from '@/queries/marketplace/schema'
import { useQuery } from '@tanstack/react-query'
import { GETMarketplacePreviewStoreById } from '../requests'
import { MarketplaceAccessMode } from '../types'
import { MARKETPLACE_PREVIEW_QUERY_KEYS } from './keys'

export const useMarketplacePreviewStoreById = (
  providerId: number,
  mode: MarketplaceAccessMode = 'preview',
  options: CustomQueryOptions<MarketplaceStore | null> = {}
) => {
  return useQuery({
    queryKey: MARKETPLACE_PREVIEW_QUERY_KEYS.store(mode, providerId),
    queryFn: () => GETMarketplacePreviewStoreById(providerId, mode),
    ...options,
  })
}
